export function modifyUrlParameters(
    href: string,
    entries: Record<string, string | number | boolean | string[]>
): URL {
    const url: URL = new URL(href);

    Object.entries(entries).forEach((entry) => {
        const key: string = entry[0];
        const value: string = Array.isArray(entry[1]) ? entry[1].join(',') : entry[1].toString();

        url.searchParams.set(key, value);
    });
    return url;
}

export function updateUrl(url: URL, replaceState = false): void {
    const href = url.href;
    const data = { path: href };

    if (!replaceState) {
        window.history.pushState(data, '', href);
        return;
    }

    window.history.replaceState(data, '', href);
}
